import {Component, Input, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {PromocionesService} from "../../../core/promociones/promociones.service";
import {MessageService} from "primeng/components/common/messageservice";
import {PromocionInfo} from "../../../core/promociones/promocion-info";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AddCodesRequestComponent} from "./add-codes-request-component";

@Component(
    {
        selector: 'add-codes-modal-promotion',
        template: `
            <div class="modal-header">
                <h4 class="modal-title">Agregar Códigos</h4>
                <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Ingresa el número de códigos que quieres agregar a la promoción {{promocion.name}}
                <form [formGroup]="addCodesForm">
                    <input class="form-control" formControlName="numCodes">
                </form>
            </div>
            <div class="modal-footer">
                <div>
                    <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('Close click')">Cancelar
                    </button>
                    <button type="button" class="btn btn-primary ml-2" [ladda]="loading"
                            (click)="addCodesPromotion()"
                            [disabled]="!addCodesForm.valid">Aceptar
                    </button>
                </div>
            </div>
        `
    }
)
export class AddCodesModalComponent implements OnInit {
    @Input() promocion: PromocionInfo;
    promociones: PromocionInfo[] = [];
    loading = false;
    detailError: string;
    incompleteResources = false;
    addCodesForm: FormGroup;

    constructor(public activeModal: NgbActiveModal,
                private promocionesService: PromocionesService,
                private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.addCodesForm = new FormGroup({
            'numCodes': new FormControl('', [Validators.required, Validators.pattern('[0-9]*')])
        });
    }

    addCodesPromotion() {
        const addCodesRequest = new AddCodesRequestComponent(this.promocion.promotionKey,
            'saldosGanalottodo',
            this.addCodesForm.value.numCodes
        );

        this.ganerateAndAddCodes(addCodesRequest);
    }

    ganerateAndAddCodes(addCodesRequest) {
        console.log('PromocionesComponent#uploadCodes');
        this.loading = true;
        this.promocionesService.generateAndAddCodes(addCodesRequest).subscribe(
            (code) => {
                this.loading = false;
                this.activeModal.close();
                this.messageService.add({
                    severity: 'success',
                    summary: '',
                    detail: 'Se cargaron codigos correctamente'
                });
            },
            (err) => {
                this.loading = false;
                console.log('PromocionesComponent#uploadCodes:error');
                console.log(err);
                this.activeModal.close();
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Error al agregar codigos'
                });
            });
    }

    // disablePromotion() {
    //     this.loading = true;
    //     this.promocionesService.changePrincipal(this.promocion).subscribe(() => {
    //         this.promocion.defaultPromotion = !this.promocion.defaultPromotion;
    //         if (this.promocion.defaultPromotion) {
    //             this.promociones.forEach((promo) => {
    //                 if (promo !== this.promocion) {
    //                     promo.defaultPromotion = false;
    //                 }
    //             });
    //         }
    //         this.activeModal.close();
    //     }, (error) => {
    //         console.log("PrincipalModalComponent:error");
    //         console.log(error);
    //         console.log(error.detail);
    //         if (error.error.detail === "Incomplete resources") {
    //             this.detailError = 'La promocion no puede marcarse como PRINCIPAL debido a que no tiene configuradas todas las imagenes';
    //             this.incompleteResources = true;
    //         }
    //         this.loading = false;
    //     });
    // }


}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/ganalottodo/add-codes-modal-component.ts